import React, { Component } from 'react'
import sLay from 'styles/modules/layout.scss'
import IconCloseThin from 'components/Icons/CloseThin'
import Button from 'components/Button/Button'
import InputMessage from '../InputMessage'

export default class FieldArrayRow extends Component {
  componentDidMount() {
    const { fields, dontInitialise } = this.props
    if (fields.length < 1 && !dontInitialise) {
      fields.push()
    }
  }
  render() {
    const {
      fields,
      FieldComponent,
      meta: { error },
      addText,
      dontInitialise,
      ...otherProps
    } = this.props
    return (
      <div style={{ marginBottom: '30px' }}>
        {fields.map((fieldName, index) => (
          <div key={index} className={sLay['layout-row']}>
            <FieldComponent classNameOuter={sLay.flex} name={fieldName} {...otherProps} />
            <Button
              icon
              size="sm"
              onClick={() => fields.remove(index)}
              style={{ marginTop: '22px', marginLeft: '10px' }}
            >
              <IconCloseThin size={24} />
            </Button>
          </div>
        ))}
        <InputMessage error={error} touched />
        <Button type="button" onClick={() => fields.push()} color="tertiary" rect size="xs">
          {addText || 'Add'}
        </Button>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Input/FieldArrayRows/FieldArrayRows.jsx